import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpensesLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.613 15.0087L35.8029 14.5914M27.7796 17.6531L37.2684 17.1087M28.909 20.2398L33.6534 19.9675",
			stroke: "black",
			strokeOpacity: .12,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.36582 5.12364C5.04757 5.12364 2.99741 12.5593 2.07167 17.3657C1.91512 18.1785 2.82078 18.7507 3.50285 18.2817V18.2817C3.97579 17.9565 4.59847 17.9498 5.07835 18.2647L5.47095 18.5223C5.97241 18.8513 6.62423 18.8397 7.11359 18.4929L7.44304 18.2594C7.85785 17.9654 8.42697 18.0282 8.76772 18.4055V18.4055C9.10876 18.7832 9.67849 18.8457 10.0933 18.551L10.6789 18.135C10.9823 17.9195 11.4032 17.9922 11.6166 18.297V18.297C11.8809 18.6744 12.4383 18.6791 12.7088 18.3061L13.1165 17.744M9.36582 5.12364C11.8775 3.32704 20.1084 2.35912 23.1362 4.49332C24.9216 6.08078 25.1116 8.61372 25.1904 10.3397M9.36582 5.12364C13.1886 5.12364 13.2882 12.9159 13.1165 17.744M22.1256 11.088C17.1451 11.088 18.4986 23.4742 14.5972 23.4742C13.0599 23.4742 13.0048 20.8836 13.1165 17.744M22.1256 11.088C24.2275 11.088 25.4103 19.546 26.6416 24.9012C28.4311 32.6847 30.0982 41.5456 32.3013 44.3721C32.457 44.5718 32.7497 44.5561 32.9114 44.3612L33.0475 44.1973C33.4237 43.744 34.0946 43.6779 34.5521 44.049L34.6586 44.1354C35.0598 44.461 35.6488 44.4005 35.9756 44.0002V44.0002C36.2674 43.6427 36.7761 43.5507 37.1747 43.7835L37.3838 43.9056C37.7869 44.1411 38.3044 44.0089 38.5452 43.609V43.609C38.7708 43.2345 39.2429 43.091 39.6387 43.2767L40.2113 43.5454C40.5535 43.7059 40.959 43.6418 41.2349 43.3835V43.3835C41.514 43.1223 41.9251 43.06 42.2691 43.2267L42.8531 43.5099C43.2185 43.687 43.6575 43.593 43.9183 43.2817V43.2817C44.194 42.9526 44.6661 42.8687 45.0383 43.0826L45.3242 43.2469C45.6653 43.4429 46.0797 43.1075 45.9718 42.7291C44.8507 38.8 43.3174 30.7434 41.6483 23.4742C40.8699 20.0843 39.854 16.7273 38.8928 14.0773C38.0018 11.621 36.0115 9.68688 33.4056 9.49616C30.6103 9.2916 27.4554 9.66204 25.1904 10.3397M22.1256 11.088C23.7664 10.5619 25.1904 10.3397 25.1904 10.3397",
			stroke: "black",
			strokeOpacity: .12,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9375 7.99604L20.5068 7.47394",
			stroke: "black",
			strokeOpacity: .12,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9375 10.6938L20.5068 10.1717",
			stroke: "black",
			strokeOpacity: .12,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.3045 35.9626C32.1574 36.9293 32.3297 38.8626 34.1957 38.8625C36.5282 38.8624 40.0585 33.7562 37.8521 33.7562C35.6457 33.7562 35.0153 38.1691 40.815 38.1691",
			stroke: "#A8AAE3",
			strokeLinecap: "round"
		})
	]
});
export default SvgExpensesLight;
